import Keycloak from 'keycloak-js';
import { guardLogin } from '@/auth/loginThrottle';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'

export const REFRESH_TOKEN_INTERVAL = 30; // seconds of minValidity passed to keycloak.updateToken()

export const FORCE_TOKEN_REFRESH = -1;

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_AUTH_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

keycloak.login = guardLogin(keycloak.login);

export default keycloak;
